$(function() {
  let recentIemsAddtoCartAjaxReq = true;
  let recentIemsRemoveProductAjaxReq = true;
  function switchOMTabs(e) {
    e.preventDefault();
    const tabid = $(this)
      .find('a')
      .attr('href');
    $('.order-management-tabs_heading').addClass('nonSelectedOM_tab');
    $('.order-management-tabs_heading').removeClass('selectedOM_tab');
    $('.order-management-tabs-container').addClass('hidden');
    $(tabid).removeClass('hidden');
    $(this).addClass('selectedOM_tab');
    $(this).removeClass('nonSelectedOM_tab');
  }

  //ADD Function
  $(document).delegate('.button-text', 'click', function(e) {
    let targetId = $(this).attr('id');
    let currentId = targetId.split('-')[1];
    let product_name = $(this)
      .parent()
      .find('.productName')
      .val();
    let quantity = parseInt(
      $(this)
        .parent()
        .find('.qty')
        .val()
    );
    let currentValue = parseInt($('.mini-cart-count .badge').text());
    let updatedValue = quantity + currentValue;
    let formId = '#addToCartForm-' + currentId;
    let form = $(formId);
    let action = form.attr('action');
    let method = form.attr('method');
    let form_data = $(formId).serialize();
    let status_update = $('#status-product-name');
    if (!recentIemsAddtoCartAjaxReq) return false;
    recentIemsAddtoCartAjaxReq = false;
    $.ajax({
      url: action,
      type: method,
      data: form_data,
      success: function() {
        recentIemsAddtoCartAjaxReq = true;
        status_update.text(product_name);
        $('.StatusUpdate').removeClass('hidden');
      },
      error: function(xht, textStatus, ex) {
        recentIemsAddtoCartAjaxReq = true;
      },
      complete: function() {
        recentIemsAddtoCartAjaxReq = true;
        $('.mini-cart-count .badge').text(updatedValue);
      }
    });
  });

  //REMOVE Function
  $(document).delegate('.remove-product', 'click', function(e) {
    let currentId = $(this).attr('id');
    let formId = '#removeFromCartForm-' + currentId;
    let form = $(formId);
    let action = form.attr('action');
    let method = form.attr('method');
    let form_data = $(formId).serialize();
    let targetActive = document.getElementsByClassName('active')[1];
    let activeElement;
    if (targetActive != undefined && targetActive != null) {
      activeElement = targetActive.innerText;
    }
    window.localStorage.setItem('activeElement', activeElement);
    if (!recentIemsRemoveProductAjaxReq) return false;
    recentIemsRemoveProductAjaxReq = false;
    $.ajax({
      url: action,
      type: method,
      data: form_data,
      success: function(data) {
        recentIemsRemoveProductAjaxReq = true;
        const sanitizedData = ACC.sanitizer.sanitizeHtmlDeeply(data);
        const hasItemsDiv = $(sanitizedData).find('.items-list-div');
        if (hasItemsDiv.length > 0) {
          let datahtml = $('.items-list-div', data).html();
          $('.items-list-div').html(datahtml);
          $('.pages').empty();
          let itemLength = $('#noOfItems').val();
          if (itemLength > noOfResults) {
            $('.left_nav').removeClass('hidden');
            $('.right_nav').removeClass('hidden');
            setPagination(itemLength);
          }
          let value = window.localStorage.getItem('activeElement');
          updateContent(value);
        } else {
          let datahtml = $('#om_tab-2', data).html();
          $('#om_tab-2').html(datahtml);
        }
      },
      error: function(xht, textStatus, ex) {
        recentIemsRemoveProductAjaxReq = true;
      },

      complete: function() {
        recentIemsRemoveProductAjaxReq = true;
        $('.items-list-div').removeClass('hidden');
      }
    });
  });

  //Setting dynamic values of page size and page no's
  let itemLength = parseInt($('#noOfItems').val());
  let noOfResults = parseInt($('#resultCount').val());
  let IdStore = new Array();
  let lastPage = '.' + 'serial-' + Math.ceil(itemLength / noOfResults);
  let firstPage = '.serial-1';
  let noOfPages = Math.ceil(itemLength / noOfResults);
  let isValid = false;
  if (noOfPages > 3) {
    isValid = true;
  }
  if (noOfPages < 3) {
    isValid = false;
  }

  //box to be appended after 1st click
  let dotBoxAppend =
    '<div class="page"><span class="pageNo dotbox">' + '..' + '</span></div>';

  //Creating pagination nav dynamically according to above values
  $(document).ready(function() {
    $('#om_tab-2').addClass('hidden');
    $('.items-list-div').removeClass('hidden');
    if (itemLength > noOfResults) {
      $('.left_nav').removeClass('hidden');
      $('.right_nav').removeClass('hidden');
    }
    if (noOfPages > 1) {
      setPagination(itemLength);
    }

    $('.serial-1').addClass('active');
    $('.right_nav .itemhistory-arrow-right').addClass('svg-icon_arrow_right');
    $('.left_nav .itemhistory-arrow-left').addClass('svg-icon_arrow_left_gray');
    if (noOfPages < 3) {
      $('.dotbox')
        .parent()
        .remove();
      $('.dotbox')
        .parent()
        .remove();

      $('.dotboxstart')
        .parent()
        .remove();
    }
  });

  //sorting the data according to pagination
  $(document).delegate('.page', 'click', function(e) {
    let pageId = $(this)
      .find('.pageNo')
      .text();
    updateContent(pageId);
  });

  //update function for sorting of data
  function updateContent(pageId) {
    let firstDiv = (pageId - 1) * noOfResults;
    let lastDiv = parseInt(firstDiv) + parseInt(noOfResults);
    let updated = new Array();
    updated = IdStore.slice(firstDiv, lastDiv);
    let hideInit = 0;
    let showInit = 0;
    let serialId = '.' + 'serial-' + pageId;

    setActive(serialId);
    sortPageId(serialId);
    assignActiveArrow();
    for (hideInit; hideInit <= IdStore.length; hideInit++) {
      let hideDiv = '#item-' + hideInit;

      $(hideDiv).hide();
    }
    for (showInit; showInit <= updated.length; showInit++) {
      let showDiv = '#' + updated[showInit];
      $(showDiv).show();
    }
  }

  // function for creating the navigation
  function setPagination(itemLength) {
    let noOfItems = itemLength;
    let noOfDiv = Math.ceil(noOfItems / noOfResults);
    let hideCount = parseInt(noOfResults) + parseInt(1);
    let initial = 1;
    let noOfCurrentDiv = document.getElementsByClassName('item-data-div');
    let classnameCount = noOfCurrentDiv.length;
    let lastDiv = '.serial-' + noOfDiv;

    for (initial; initial <= noOfDiv; initial++) {
      let endBox =
        '<div class="page endBox"><span tabindex="0" role="button" class="pageNo serial-' +
        initial +
        '" id="serial-' +
        initial +
        '">' +
        initial +
        '</span></div>';
      let midBox =
        '<div class="page midBox hidden"><span tabindex="0" role="button" class="pageNo serial-' +
        initial +
        '" id="serial-' +
        initial +
        '">' +
        initial +
        '</span></div>';
      if (initial == 1) {
        $('.pages').append(endBox);
        let dotBox =
          '<div class="page hidden"><span class="pageNo dotboxstart">' +
          '..' +
          '</span></div>';
        $('.pages').append(dotBox);
      }
      if (initial == 2 || initial == noOfDiv) {
        $('.pages').append(endBox);
      }
      if (initial > 2 && initial < noOfDiv - 1) {
        $('.pages').append(midBox);
      }
      if (noOfDiv > 3) {
        if (initial == noOfDiv - 1) {
          let midBox =
            '<div class="page hidden"><span tabindex="0" role="button" class="pageNo serial-' +
            initial +
            '" id="serial-' +
            initial +
            '">' +
            initial +
            '</span></div>';
          $('.pages').append(midBox);
          let dotBox =
            '<div class="page"><span class="pageNo dotbox">' +
            '..' +
            '</span></div>';
          $('.pages').append(dotBox);
        }
      }
    }
    $('.serial-1').addClass('first');
    $(lastDiv).addClass('last');

    for (let j = 0; j < classnameCount; j++) {
      let k = j + 1;
      noOfCurrentDiv[j].id = 'item-' + k;
      IdStore.push(noOfCurrentDiv[j].id);
    }

    for (hideCount; hideCount <= noOfItems; hideCount++) {
      let hideDiv = '#item-' + hideCount;
      $(hideDiv).hide();
    }
  }

  function setActive(serialId) {
    if (!$(serialId).hasClass('active')) {
      $('span.active').removeClass('active');
      $(serialId).addClass('active');
      if (
        $(serialId)
          .parent()
          .hasClass('hidden')
      ) {
        $(serialId)
          .parent()
          .removeClass('hidden');
      }
    }
  }

  function sortPageId(serialId) {
    if (serialId != firstPage && serialId != lastPage) {
    }
  }

  $(document).delegate('.left_nav,.right_nav', 'click', function(e) {
    let targetObj = $(this).attr('id');
    let activeElement = parseInt(
      document.getElementsByClassName('active')[1].innerHTML
    );
    let target;
    if (
      targetObj.length !== 0 &&
      targetObj !== undefined &&
      targetObj !== null
    ) {
      target = targetObj.split('-')[1];
    }

    let activeClass = '#' + 'serial-' + activeElement;
    let pageId;
    assignActiveArrow();
    if (activeElement > 1 && activeElement < noOfPages) {
      assignVisibility(activeElement, target);
    }

    if (target == 'left_nav') {
      if ($(activeClass).hasClass('first')) {
        return false;
      } else {
        pageId = activeElement - 1;
        updateContent(pageId);
      }
    } else if (target == 'right_nav') {
      if ($(activeClass).hasClass('last')) {
        return false;
      } else {
        pageId = activeElement + 1;
        updateContent(pageId);
      }
    }
  });

  function assignActiveArrow() {
    let activeElement;
    let targetActive = document.getElementsByClassName('active')[1];
    if (targetActive != undefined && targetActive != null) {
      activeElement = parseInt(targetActive.innerHTML);
    }
    let lastDiv = Math.ceil(itemLength / noOfResults);
    let firstDiv = parseInt(1);
    if (activeElement > firstDiv && activeElement < lastDiv) {
      $('.right_nav .itemhistory-arrow-right').addClass('svg-icon_arrow_right');
      $('.left_nav .itemhistory-arrow-left').addClass('svg-icon_arrow_left');
      $('.right_nav .itemhistory-arrow-right').removeClass(
        'svg-icon_arrow_right_gray'
      );
      $('.left_nav .itemhistory-arrow-left').removeClass(
        'svg-icon_arrow_left_gray'
      );
    }
    if (activeElement == firstDiv) {
      $('.right_nav .itemhistory-arrow-right').addClass('svg-icon_arrow_right');
      $('.left_nav .itemhistory-arrow-left').addClass(
        'svg-icon_arrow_left_gray'
      );
      $('.right_nav .itemhistory-arrow-right').removeClass(
        'svg-icon_arrow_right_gray'
      );
    }
    if (activeElement == lastDiv) {
      $('.left_nav .itemhistory-arrow-left').removeClass(
        'svg-icon_arrow_left_gray'
      );
      $('.right_nav .itemhistory-arrow-right').addClass(
        'svg-icon_arrow_right_gray'
      );
      $('.left_nav .itemhistory-arrow-left').addClass('svg-icon_arrow_left');
    }
  }

  function assignVisibility(activeElement, target) {
    if (isValid) {
      let lastDiv = Math.ceil(itemLength / noOfResults);
      let firstDiv = parseInt(1);
      let next = parseInt(activeElement) + 1;
      let previous = parseInt(activeElement) - 1;
      let addVisibilitynext = '.' + 'serial-' + parseInt(next);
      let addVisibilityprev = '.' + 'serial-' + parseInt(previous);
      let current = '.' + 'serial-' + activeElement;

      if (activeElement > 2) {
        if (target == 'right_nav') {
          if (activeElement > firstDiv && activeElement < lastDiv) {
            $('.dotboxstart')
              .parent()
              .removeClass('hidden');
            if (next == lastDiv - 1) {
              $('.dotbox')
                .parent()
                .addClass('hidden');
            }
            if (
              $(addVisibilitynext)
                .parent()
                .hasClass('hidden')
            ) {
              $(addVisibilitynext)
                .parent()
                .removeClass('hidden');
              $(addVisibilityprev)
                .parent()
                .addClass('hidden');
            }
          }
        }
      }
      if (target == 'left_nav') {
        if (activeElement > firstDiv && activeElement < lastDiv) {
          $('.dotbox')
            .parent()
            .removeClass('hidden');
          if (previous == firstDiv + 1) {
            $('.dotboxstart')
              .parent()
              .addClass('hidden');
          }
          if (
            $(addVisibilityprev)
              .parent()
              .hasClass('hidden')
          ) {
            $(addVisibilityprev)
              .parent()
              .removeClass('hidden');
            $(addVisibilitynext)
              .parent()
              .addClass('hidden');
          }
        }
      }
    }
  }
});
